import { navigatorShare } from "../Utils";
import BreakpointFeature from "./feature/Breakpoint";
import { BtnShareTrigger } from "./feature/BtnShareTrigger";

export abstract class AbsShare {
    abstract open(): void;
    abstract close(): void;
    abstract toggle(): void;

    abstract remove(): void;
    abstract create(): void;


    abstract get option(): ShareOption;

    // 브레이크 포인트 인스턴스
    abstract breakpoint: BreakpointFeature | null;
    // 공유하기 트리거 버튼 인스턴스
    abstract btnShareTrigger: BtnShareTrigger | null;

}

